import { create } from 'zustand';

type NetworkState = {
  offline: boolean;
  ordersListErrorPage: boolean;
  lastSuccessAt: number | null;
  recoveredUntil: number;
  setOffline: () => void;
  setOrdersListErrorPage: (visible: boolean) => void;
  setOnline: () => void;
};

export const useNetwork = create<NetworkState>((set) => ({
  offline: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  ordersListErrorPage: false,
  lastSuccessAt: null,
  recoveredUntil: 0,
  setOffline: () => set({ offline: true, recoveredUntil: 0 }),
  setOrdersListErrorPage: (visible) => set({ ordersListErrorPage: visible }),
  setOnline: () => set((current) => ({
    offline: false,
    lastSuccessAt: Date.now(),
    recoveredUntil: current.offline ? Date.now() + 2000 : current.recoveredUntil,
  })),
}));
